module.exports = __webpack_public_path__ + "static/media/2.964f229a.jpg";